import filter from 'lodash/filter';
import find from 'lodash/find';
import map from 'lodash/map';
import React, { ChangeEventHandler, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks/redux';
import { ICategory } from '../../models/ICategory';
import styles from './index.module.css';

interface IProps {
	categories: ICategory[];
	value: ICategory;
	onChange: ChangeEventHandler<HTMLSelectElement>;
}

export const CategorySelect = ({ categories, value, onChange }: IProps) => {
	const { language } = useAppSelector(state => state.languageSlice);
	const firstCategories = filter(categories, c => c.parent_id === null && c.id !== 0);
	const secondCategories = filter(categories, c => c.parent_id !== null);
	const { t, i18n } = useTranslation('translation');

	useEffect(() => {
		i18n.changeLanguage(language);
	}, [language]);

	return (
		<select className={styles.select} name="categorySelect" value={value.id} onChange={onChange} id="categorySelect">
			<option value={find(categories, c => c.id === 0).id}>{t('Все категории')}</option>
			{map(firstCategories, f => (
				<optgroup label={f.name} key={f.id}>
					{map(secondCategories, s => {
						return s.parent_id === f.id
							? (<option value={s.id} key={s.id}>
								{ s.code === 'all' ? `${find(firstCategories, (c) => c.id === s.parent_id).name} - ${s.name}` : s.name }
							</option>)
							: null;
					})}
				</optgroup>
			))}
		</select>
	);
};
